import { render, staticRenderFns } from "./CreateEmployeeDialog.vue?vue&type=template&id=beafa20e&scoped=true"
import script from "./CreateEmployeeDialog.vue?vue&type=script&lang=js"
export * from "./CreateEmployeeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beafa20e",
  null
  
)

export default component.exports